import { render, staticRenderFns } from "./CatalogFilters.vue?vue&type=template&id=ed53dd6a&scoped=true"
import script from "./CatalogFilters.vue?vue&type=script&lang=js"
export * from "./CatalogFilters.vue?vue&type=script&lang=js"
import style0 from "./CatalogFilters.vue?vue&type=style&index=0&id=ed53dd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed53dd6a",
  null
  
)

export default component.exports